// Importer les éléments pour Vue
import Vue from 'vue'
import Router from 'vue-router'

// Importer les différents composants

// Partie site Web
// Accueil
import WebHome from '@/components/SiteWeb/WebHome'
// Profil
import WebConcept from '@/components/SiteWeb/WebConcept'
import WebTricho from '@/components/SiteWeb/WebTricho'
import WebPresse from '@/components/SiteWeb/WebPresse'
// Articles
import WebArticles from '@/components/SiteWeb/WebArticles'
// Tarifs
import WebTarifsEnfants from '@/components/SiteWeb/WebTarifsEnfants'
import WebTarifsFemmes from '@/components/SiteWeb/WebTarifsFemmes'
import WebTarifsHommes from '@/components/SiteWeb/WebTarifsHommes'
import WebTarifsSoins from '@/components/SiteWeb/WebTarifsSoins'

// Mentions légales
import WebPlan from '@/components/SiteWeb/WebPlan'

// Partie application Web
// Login et Accueil
import AppLogin from '@/components/Application/AppLogin'
import AppHome from '@/components/Application/AppHome'
// Encaissement
import AppCollection from '@/components/Application/AppCollection'
import AppCollectionSelect from '@/components/Application/AppCollectionSelect'
import AppCollectionSlot from '@/components/Application/AppCollectionSlot'
import AppCollectionPaiement from '@/components/Application/AppCollectionPaiement'
import AppCollectionEstimate from '@/components/Application/AppCollectionEstimate'
import AppCollectionInvoice from '@/components/Application/AppCollectionInvoice'
import AppCollectionReedition from '@/components/Application/AppCollectionReedition'
import AppCollectionAdmin from '@/components/application/AppCollectionAdmin'
// Publications Web
import AppPublicationsChoice from '@/components/Application/AppPublicationsChoice'
import AppPublicationsCreate from '@/components/Application/AppPublicationsCreate'
import AppPublicationsEdit from '@/components/Application/AppPublicationsEdit'
// Clients
import AppClientsChoice from '@/components/Application/AppClientsChoice'
import AppClientsCreate from '@/components/Application/AppClientsCreate'
import AppClientsEdit from '@/components/Application/AppClientsEdit'
import AppClientsHistory from '@/components/Application/AppClientsHistory'
// Produits
import AppProductsChoice from '@/components/Application/AppProductsChoice'
import AppProductsCreate from '@/components/Application/AppProductsCreate'
import AppProductsEdit from '@/components/Application/AppProductsEdit'
// Tarifs
import AppTarifsChoice from '@/components/Application/AppTarifsChoice'
import AppTarifsCreate from '@/components/Application/AppTarifsCreate'
import AppTarifsEdit from '@/components/Application/AppTarifsEdit'
// Dépenses
import AppSpendingsChoice from '@/components/Application/AppSpendingsChoice'
import AppSpendingsCreate from '@/components/Application/AppSpendingsCreate'
import AppSpendingsEdit from '@/components/Application/AppSpendingsEdit'
// Statistiques
import AppStatistics from '@/components/Application/AppStatistics'
import AppStatisticsPDFIncome from '@/components/Application/AppStatisticsPDFIncome'
import AppStatisticsPDFSpending from '@/components/Application/AppStatisticsPDFSpending'
// Paramètres
import AppSettings from '@/components/Application/AppSettings'

// Utilisation du Router de Vue
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    /* SITE WEB */
    {
      path: '/',
      name: 'WebHome',
      component: WebHome
    },
    {
      path: '/Articles',
      name: 'WebArticles',
      component: WebArticles
    },
    {
      path: '/Concept',
      name: 'WebConcept',
      component: WebConcept
    },
    {
      path: '/Trichotherapy',
      name: 'WebTrichotherapy',
      component: WebTricho
    },
    {
      path: '/Presse',
      name: 'WebPrese',
      component: WebPresse
    },
    {
      path: '/Tarifs/Enfants',
      name: 'WebTarifsEnfants',
      component: WebTarifsEnfants
    },
    {
      path: '/Tarifs/Femmes',
      name: 'WebTarifsFemmes',
      component: WebTarifsFemmes
    },
    {
      path: '/Tarifs/Hommes',
      name: 'WebTarifsHommes',
      component: WebTarifsHommes
    },
    {
      path: '/Tarifs/Soins-Energetiques',
      name: 'WebTarifsSoins',
      component: WebTarifsSoins
    },
    {
      path: '/MentionsLegales',
      name: 'WebPlan',
      component: WebPlan
    },
    /* APPLICATION */
    {
      path: '/App/Login',
      name: 'AppLogin',
      component: AppLogin
    },
    {
      path: '/App/Home',
      name: 'Home',
      component: AppHome
    },
    {
      path: '/App/Collection',
      name: 'Collection',
      component: AppCollection
    },
    {
      path: '/App/Collection/Select',
      name: 'CollectionSelect',
      component: AppCollectionSelect
    },
    {
      path: '/App/Collection/Slot',
      name: 'CollectionSlot',
      component: AppCollectionSlot
    },
    {
      path: '/App/Collection/Paiement',
      name: 'AppCollectionPaiement',
      component: AppCollectionPaiement
    },
    {
      path: '/App/Collection/Paiement/Facture',
      name: 'AppCollectionInvoice',
      component: AppCollectionInvoice
    },
    {
      path: '/App/Collection/Paiement/Devis',
      name: 'AppCollectionEstimate',
      component: AppCollectionEstimate
    },
    {
      path: '/App/Collection/Paiement/Reedition',
      name: 'AppCollectionReedition',
      component: AppCollectionReedition
    },
    {
      path: '/App/Collection/Paiement/Admin',
      name: 'AppCollectionAdmin',
      component: AppCollectionAdmin
    },
    {
      path: '/App/Publications',
      name: 'Publication',
      component: AppPublicationsChoice
    },
    {
      path: '/App/Publications/Create',
      name: 'PublicationCreate',
      component: AppPublicationsCreate
    },
    {
      path: '/App/Publications/Edit',
      name: 'PublicationEdit',
      component: AppPublicationsEdit
    },
    {
      path: '/App/Clients',
      name: 'Clients',
      component: AppClientsChoice
    },
    {
      path: '/App/Clients/Create',
      name: 'ClientCreate',
      component: AppClientsCreate
    },
    {
      path: '/App/Clients/Edit',
      name: 'ClientEdit',
      component: AppClientsEdit
    },
    {
      path: '/App/Clients/Historique',
      name: 'ClientHistorique',
      component: AppClientsHistory
    },
    {
      path: '/App/Products',
      name: 'ProductsList',
      component: AppProductsChoice
    },
    {
      path: '/App/Products/Create',
      name: 'ProductCreate',
      component: AppProductsCreate
    },
    {
      path: '/App/Products/Edit',
      name: 'ProductCreate',
      component: AppProductsEdit
    },
    {
      path: '/App/Tarifs',
      name: 'TarifsList',
      component: AppTarifsChoice
    },
    {
      path: '/App/Tarifs/Create',
      name: 'TarifsCreate',
      component: AppTarifsCreate
    },
    {
      path: '/App/Tarifs/Edit',
      name: 'TarifsEdit',
      component: AppTarifsEdit
    },
    {
      path: '/App/Spendings',
      name: 'SpendingsList',
      component: AppSpendingsChoice
    },
    {
      path: '/App/Spendings/Create',
      name: 'SpendingsCreate',
      component: AppSpendingsCreate
    },
    {
      path: '/App/Spendings/Edit',
      name: 'SpendingsEdit',
      component: AppSpendingsEdit
    },
    {
      path: '/App/Statistics',
      name: 'Statistics',
      component: AppStatistics
    },
    {
      path: '/App/Statistics/Incomes',
      name: 'StatisticsIncomes',
      component: AppStatisticsPDFIncome
    },
    {
      path: '/App/Statistics/Spendings',
      name: 'StatisticsSpendings',
      component: AppStatisticsPDFSpending
    },
    {
      path: '/App/Settings',
      name: 'Settings',
      component: AppSettings
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js